import { AvailableLocale } from './types'

export const AVAILABLE_LOCALES = ['en-US', 'es-ES'] as const
export const SUPPORTED_LOCALES = [...AVAILABLE_LOCALES]

export const LOCALE_TITLES = {
    'en-US': 'English',
    'es-ES': 'Español',
}

const localeRouteNameMap: Record<AvailableLocale | string, string | AvailableLocale> = {
    // to locale
    en: 'en-US',
    es: 'es-ES',
    // to routeName
    'en-US': 'en',
    'es-ES': 'es',
}

export const mapLocaleRouteParamName = (localeOrRoutName: AvailableLocale | string): string | AvailableLocale =>
    localeRouteNameMap[localeOrRoutName]

export const mapLocaleToHrefLang = (locale: AvailableLocale): string => ({ 'en-US': 'en', 'es-ES': 'es' })[locale]

export function resolveSupportedLocale(locale: string | undefined): AvailableLocale | undefined {
    if (!locale) {
        return undefined
    }
    if (SUPPORTED_LOCALES.includes(locale as AvailableLocale)) {
        return locale as AvailableLocale
    }

    const matchedLocale = SUPPORTED_LOCALES.find((loc) => loc.startsWith(locale))
    return matchedLocale as AvailableLocale
}
